import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ItemManagement20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M13.5304 9.03033L12.4697 7.96967L9.00006 11.4393L7.53039 9.96967L6.46973 11.0303L9.00006 13.5607L13.5304 9.03033Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.25 1C6.25 0.585786 6.58579 0.25 7 0.25H13C13.4142 0.25 13.75 0.585786 13.75 1V1.25H17.5C18.1904 1.25 18.75 1.80964 18.75 2.5V18.5C18.75 19.1904 18.1904 19.75 17.5 19.75H2.5C1.80964 19.75 1.25 19.1904 1.25 18.5V2.5C1.25 1.80965 1.80964 1.25 2.5 1.25H6.25V1ZM13.75 4V2.75H17.25V18.25H2.75V2.75H6.25V4C6.25 4.41421 6.58579 4.75 7 4.75H13C13.4142 4.75 13.75 4.41421 13.75 4ZM7.75 1.75V3.25H12.25V1.75H7.75Z'
      fill='currentColor'
    />
  </Svg>
);

ItemManagement20.displayName = 'ItemManagement20';
export default ItemManagement20;
